"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementType = exports.CustomForm = void 0;
var react_1 = __importStar(require("react"));
var react_toastify_1 = require("react-toastify");
var CustomButton_1 = __importDefault(require("./CustomButton"));
var CustomInput_1 = __importDefault(require("./CustomInput"));
var CustomTextarea_1 = __importDefault(require("./CustomTextarea"));
var CustomCheckbox_1 = __importDefault(require("./CustomCheckbox"));
var CustomRadioButton_1 = __importDefault(require("./CustomRadioButton"));
var CustomSelect_1 = __importDefault(require("./CustomSelect"));
var CustomDateTimePicker_1 = __importDefault(require("./CustomDateTimePicker"));
var CustomText_1 = __importDefault(require("./CustomText"));
var CustomDivider_1 = __importDefault(require("./CustomDivider"));
var CustomRichTextbox_1 = __importDefault(require("./CustomRichTextbox"));
var CustomTreeView_1 = __importDefault(require("./CustomTreeView"));
var CustomAutocompleteInput_1 = __importDefault(require("./CustomAutocompleteInput"));
var CustomFileUploader_1 = __importDefault(require("./CustomFileUploader"));
var ElementType;
(function (ElementType) {
    ElementType["INPUT"] = "input";
    ElementType["TEXTAREA"] = "textarea";
    ElementType["CHECKBOX"] = "checkbox";
    ElementType["RADIO"] = "radio";
    ElementType["SELECT"] = "select";
    ElementType["DATETIMEPICKER"] = "datetimepicker";
    ElementType["TEXT"] = "text";
    ElementType["DIVIDER"] = "divider";
    ElementType["RICHTEXTBOX"] = "richtextbox";
    ElementType["TREEVIEW"] = "treeview";
    ElementType["BUTTON"] = "button";
    ElementType["AUTOCOMPLETEINPUT"] = "autocompleteinput";
    ElementType["FILEUPLOADER"] = "fileuploader";
})(ElementType || (ElementType = {}));
exports.ElementType = ElementType;
var CustomForm = function (_a) {
    var elements = _a.elements, innerRowCustomClass = _a.innerRowCustomClass, onSubmit = _a.onSubmit, _b = _a.confirmLabel, confirmLabel = _b === void 0 ? "Confirm" : _b, // Varsayılan değer
    _c = _a.cancelLabel, // Varsayılan değer
    cancelLabel = _c === void 0 ? "Cancel" : _c, // Varsayılan değer
    handleCancel = _a.handleCancel, _d = _a.showConfirmButton, showConfirmButton = _d === void 0 ? true : _d, // Varsayılan olarak görünür
    _e = _a.showCancelButton, // Varsayılan olarak görünür
    showCancelButton = _e === void 0 ? false : _e;
    var formRef = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = (0, react_1.useState)(false), submitted = _g[0], setSubmitted = _g[1];
    var handleConfirm = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var form, customSelectValid, isValid, formValues_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setSubmitted(true); // Form gönderimi tetiklendi
                    form = formRef.current;
                    if (!form)
                        return [2 /*return*/];
                    customSelectValid = true;
                    elements.forEach(function (element) {
                        if (element.type === ElementType.SELECT && element.required) {
                            var selectElement = element;
                            // Eğer değer boş (string) veya boş array ise geçersiz kabul edin
                            if ((Array.isArray(selectElement.value) && selectElement.value.length === 0) ||
                                (!Array.isArray(selectElement.value) && !selectElement.value)) {
                                customSelectValid = false;
                            }
                        }
                    });
                    isValid = form.checkValidity() && customSelectValid;
                    if (!isValid) return [3 /*break*/, 6];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    formValues_1 = {};
                    Array.from(form.elements).forEach(function (element) {
                        if (element instanceof HTMLInputElement ||
                            element instanceof HTMLTextAreaElement ||
                            element instanceof HTMLSelectElement) {
                            if (element.id) {
                                var name_1 = element.name || element.id;
                                if (element instanceof HTMLInputElement &&
                                    element.type === ElementType.RADIO) {
                                    if (element.checked) {
                                        formValues_1[name_1] = element.value;
                                    }
                                }
                                else if (element instanceof HTMLInputElement &&
                                    element.type === ElementType.CHECKBOX) {
                                    formValues_1[name_1] = element.checked;
                                }
                                else if (element instanceof HTMLSelectElement &&
                                    element.multiple) {
                                    var selectedOptions = Array.from(element.selectedOptions).map(function (option) { return option.value; });
                                    formValues_1[name_1] = selectedOptions;
                                }
                                else if (element instanceof HTMLSelectElement) {
                                    formValues_1[name_1] = [element.value];
                                }
                                else {
                                    formValues_1[name_1] = element.value;
                                }
                            }
                        }
                    });
                    // Özel elemanlar için (örneğin RichTextbox) değerleri ekleyin
                    elements.forEach(function (element) {
                        if ("value" in element && element.type === ElementType.RICHTEXTBOX) {
                            formValues_1[element.id] = element.value;
                        }
                    });
                    return [4 /*yield*/, onSubmit(formValues_1)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    react_toastify_1.toast.error("Form gönderimi sırasında bir hata oluştu.");
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [3 /*break*/, 7];
                case 6:
                    react_toastify_1.toast.error("Gerekli tüm alanları doldurunuz.");
                    form.classList.add("was-validated");
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    // Elemanları satır, sütun ve iç satıra göre gruplama
    var groupedElements = elements.reduce(function (acc, el) {
        var row = el.rowId || 0;
        var col = el.colId || 0;
        var innerRow = el.innerRowId || 0;
        if (!acc[row])
            acc[row] = {};
        if (!acc[row][col])
            acc[row][col] = {};
        if (!acc[row][col][innerRow])
            acc[row][col][innerRow] = [];
        acc[row][col][innerRow].push(el);
        return acc;
    }, {});
    return (react_1.default.createElement("form", { ref: formRef, noValidate: true, className: "needs-validation", autoComplete: "off" },
        Object.entries(groupedElements).map(function (_a) {
            var rowId = _a[0], columns = _a[1];
            return (react_1.default.createElement("div", { className: "row", key: "row-".concat(rowId) }, Object.entries(columns).map(function (_a) {
                var colId = _a[0], innerRows = _a[1];
                return (react_1.default.createElement("div", { className: "col", key: "col-".concat(rowId, "-").concat(colId) }, Object.entries(innerRows).map(function (_a) {
                    var innerRowId = _a[0], elements = _a[1];
                    return (react_1.default.createElement("div", { className: "row ".concat(innerRowCustomClass), key: "inner-row-".concat(rowId, "-").concat(colId, "-").concat(innerRowId) }, elements.map(function (element) { return (react_1.default.createElement("div", { className: element.colClass || "col-12", key: element.id }, element.type === ElementType.TEXT ? (react_1.default.createElement(CustomText_1.default, __assign({}, element))) : element.type === ElementType.INPUT ? (react_1.default.createElement(CustomInput_1.default, __assign({}, element))) : element.type === ElementType.TEXTAREA ? (react_1.default.createElement(CustomTextarea_1.default, __assign({}, element))) : element.type === ElementType.CHECKBOX ? (react_1.default.createElement(CustomCheckbox_1.default, __assign({}, element))) : element.type === ElementType.RADIO ? (react_1.default.createElement(CustomRadioButton_1.default, __assign({}, element))) : element.type === ElementType.SELECT ? (react_1.default.createElement(CustomSelect_1.default, __assign({}, element, { submitted: submitted }))) : element.type === ElementType.DATETIMEPICKER ? (react_1.default.createElement(CustomDateTimePicker_1.default, __assign({}, element, { submitted: submitted }))) : element.type === ElementType.DIVIDER ? (react_1.default.createElement(CustomDivider_1.default, __assign({}, element))) : element.type === ElementType.RICHTEXTBOX ? (react_1.default.createElement(CustomRichTextbox_1.default, __assign({}, element))) : element.type === ElementType.TREEVIEW ? (react_1.default.createElement(CustomTreeView_1.default, __assign({}, element))) : element.type === ElementType.BUTTON ? (react_1.default.createElement(CustomButton_1.default, __assign({}, element, { isLoading: isLoading }))) : element.type === ElementType.AUTOCOMPLETEINPUT ? (react_1.default.createElement(CustomAutocompleteInput_1.default, __assign({}, element))) : element.type === ElementType.FILEUPLOADER ? (
                    // FILEUPLOADER elemanı için CustomFileUploader'ı render ediyoruz
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(CustomFileUploader_1.default, { url: element.url, multi: element.multi, allowedTypes: element.allowedTypes, maxFile: element.maxFile, maxSize: element.maxSize, onUploadComplete: element.onUploadComplete, onRemoveUploaded: element.onRemoveUploaded, onPendingChange: element.onPendingChange, label: element.label, translations: element.translations }))) : null)); })));
                })));
            })));
        }),
        (showConfirmButton || showCancelButton) && (react_1.default.createElement("div", { className: "card-footer mt-3" },
            react_1.default.createElement("div", { className: "form-actions mt-3", style: { display: "flex", justifyContent: "flex-end", gap: "10px" } },
                showCancelButton && (react_1.default.createElement(CustomButton_1.default, { label: cancelLabel, className: "btn btn-secondary", onClick: handleCancel || (function () { }), isLoading: isLoading })),
                showConfirmButton && (react_1.default.createElement(CustomButton_1.default, { label: confirmLabel, className: "btn btn-primary", onClick: handleConfirm, isLoading: isLoading })))))));
};
exports.CustomForm = CustomForm;
exports.default = CustomForm;
